import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Input,
  Button,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";

import apiClient from "../../axiosInstance";
import showAlert from "../../components/Common/ShowAlert";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const UpdateExpense = () => {
  const [breadcrumbItems] = useState([
    { title: "Daryeel", link: "/" },
    { title: "Update Expense", link: "#" },
  ]);

  const navigate = useNavigate();
  const { id } = useParams();

  const [expenseTypes, setExpenseTypes] = useState([]);
  const [branches, setBranches] = useState([]);

  const [formData, setFormData] = useState({
    expense_type_id: "",
    amount: "",
    description: "",
    expense_date: "",
    branch_id: "",
  });

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "white",
    }),
  };

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [typesRes, branchesRes, expenseRes] = await Promise.all([
          apiClient.get("/expense/types"),
          apiClient.get("/branches/getbranches"),
          apiClient.get(`/expense/${id}`),
        ]);

        setExpenseTypes(typesRes.data.response || []);
        setBranches(branchesRes.data.response || []);

        const exp = expenseRes.data.response;
        setFormData({
          expense_type_id: exp?.expense_type_id || "",
          amount: exp?.amount ?? "",
          description: exp?.description || "",
          expense_date: (exp?.expense_date || "").slice(0, 10),
          branch_id: exp?.branch_id || "",
        });
      } catch (err) {
        console.error("Error loading expense:", err);
      }
    };

    fetchAll();
  }, [id]);

  const expenseTypeOptions = useMemo(
    () => [
      { label: "Select Expense Type", value: "" },
      ...expenseTypes.map((t) => ({ label: t.name, value: t.id })),
    ],
    [expenseTypes],
  );

  const branchOptions = useMemo(
    () => [
      { label: "Select Branch", value: "" },
      ...branches.map((b) => ({ label: b.name, value: b.id })),
    ],
    [branches],
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await apiClient.put(`/expense/${id}`, {
        ...formData,
        amount: formData.amount ? Number(formData.amount) : 0,
      });

      await showAlert({
        title: "Expense",
        text: res.data.message,
        icon: res.data.status,
        goBack: res.data.status === "success",
        navigate,
        timer: 3000,
      });
    } catch (err) {
      console.error("Error updating expense:", err);
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Update Expense" breadcrumbItems={breadcrumbItems} />
        <form onSubmit={handleSubmit}>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <h4 className="card-title d-flex justify-content-between align-items-center">
                    Update Expense
                    <i
                      className="ri-arrow-left-line"
                      style={{ fontSize: "1.25rem", cursor: "pointer" }}
                      onClick={() => navigate(-1)}
                    ></i>
                  </h4>

                  <hr className="bg-primary" />

                  <Row>
                    <Col lg="4" className="mt-3">
                      <Label className="form-label">Expense Type</Label>
                      <Select
                        options={expenseTypeOptions}
                        value={
                          expenseTypeOptions.find(
                            (o) => o.value === formData.expense_type_id,
                          ) || expenseTypeOptions[0]
                        }
                        onChange={(opt) =>
                          setFormData((p) => ({
                            ...p,
                            expense_type_id: opt?.value || "",
                          }))
                        }
                        styles={customStyles}
                        classNamePrefix="select2-selection form-control"
                        required
                      />
                    </Col>

                    <Col lg="4" className="mt-3">
                      <Label className="form-label">Branch</Label>
                      <Select
                        options={branchOptions}
                        value={
                          branchOptions.find(
                            (o) => o.value === formData.branch_id,
                          ) || branchOptions[0]
                        }
                        onChange={(opt) =>
                          setFormData((p) => ({
                            ...p,
                            branch_id: opt?.value || "",
                          }))
                        }
                        styles={customStyles}
                        classNamePrefix="select2-selection form-control"
                        required
                      />
                    </Col>

                    <Col lg="4" className="mt-3">
                      <Label className="form-label">Expense Date</Label>
                      <Input
                        type="date"
                        name="expense_date"
                        value={formData.expense_date}
                        onChange={handleInputChange}
                        required
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col lg="4" className="mt-3">
                      <Label className="form-label">Amount</Label>
                      <Input
                        type="number"
                        step="0.01"
                        name="amount"
                        placeholder="0.00"
                        value={formData.amount}
                        onChange={handleInputChange}
                        required
                      />
                    </Col>
                    <Col lg="8" className="mt-3">
                      <Label className="form-label">Description</Label>
                      <Input
                        type="text"
                        name="description"
                        placeholder="Description"
                        value={formData.description}
                        onChange={handleInputChange}
                      />
                    </Col>
                  </Row>

                  <div className="row d-flex justify-content-end">
                    <div className="col-md-2 col-6">
                      <Button
                        type="submit"
                        color="success"
                        className="mt-4 w-100"
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </form>
      </Container>
    </div>
  );
};

export default UpdateExpense;
